// Работа с файлами каталога панели (App\Models\File): форматирование для вывода.
export default class FileLib {
    // «45.0 МБ» / «512 КБ». null — размер неизвестен: запись в files легко переживает свой файл
    // на диске (File::getSizeAttribute отдаёт null вместо исключения). Текст-заглушку выбирает
    // вызывающий — в списке это «—», в карточке «файл на диске не найден».
    static formatterSize(bytes) {
        if (bytes === null || bytes === undefined) return null;
        if (bytes < 1048576) return `${Math.max(1, Math.round(bytes / 1024))} КБ`;
        return `${(bytes / 1048576).toFixed(1)} МБ`;
    }
}
